import { forwardRef } from 'react';

import { cn } from '../../v2';

const ModalBody = forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>((props, ref) => {
  const { children, className, ...rest } = props;
  return (
    <div className={cn('bg-background shadow-overlayShadow rounded-md border', className)} ref={ref} {...rest}>
      {children}
    </div>
  );
});

ModalBody.displayName = 'ModalBody';

export { ModalBody };
